import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ActionPreviewInfoBlockSection } from '../../../../../services/ai-poc/ai-poc.service';

/**
 * Generic `info_block` section — a tinted panel with a free-form body.
 * Also serves as the forward-compat fallback when the host card hits an
 * unknown section kind it doesn't recognize.
 */
@Component({
    selector: 'app-ap-info-block-section',
    templateUrl: './info-block-section.component.html',
    styleUrls: ['./info-block-section.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
})
export class ActionPreviewInfoBlockSectionComponent {
    @Input({ required: true }) section!: ActionPreviewInfoBlockSection;
}
